import { useMutation, useQueryClient } from '@tanstack/react-query';

import { hardwareOverviewEquipmentItemKey } from '@pages/EquipmentDetails/services/useHardwareOverviewEquipmentItemQuery';
import { hardwareOverviewDetailsKey } from '@pages/HardwareOverviewDetails/services/useHardwareOverviewDetailsQuery';

import { apiClient } from '@services/apiClient';

interface IData {
  formData: {
    location_info: string;
    location_id: string;
    wo_asset_id?: string;
  };
  equipmentType?: string;
  itemId?: string;
}

const locationChangeFn = (data: IData) =>
  apiClient.post(`${APP_API_URL}${data.equipmentType}/save-info/${data.itemId}`, data.formData);

export const useLocationChangeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: locationChangeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewEquipmentItemKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewDetailsKey()[0]] });
    },
  });
};
